module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?3a0b3b123a2a3ffd394505a9966231b8";